import { render, staticRenderFns } from "./ProductSheetsView.vue?vue&type=template&id=a826d5d8&scoped=true"
import script from "./ProductSheetsView.vue?vue&type=script&lang=js"
export * from "./ProductSheetsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a826d5d8",
  null
  
)

export default component.exports